import {
  HTTP_SENDEMAILBUHEAD_FETCHING,
  HTTP_SENDEMAILBUHEAD_SUCCESS,
  HTTP_SENDEMAILBUHEAD_FAILED,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_SENDEMAILBUHEAD_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_SENDEMAILBUHEAD_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_SENDEMAILBUHEAD_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
